import { render, staticRenderFns } from "./pcpay.vue?vue&type=template&id=4220f5f3&"
import script from "./pcpay.vue?vue&type=script&lang=js&"
export * from "./pcpay.vue?vue&type=script&lang=js&"
import style0 from "./pcpay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports